import { Stack, Typography } from '@mui/material'
import React from 'react'

export function MainInfo({ label, value }: { label: string; value: string | number | boolean | null | undefined }) {
  const displayValue =
    typeof value === "boolean"
      ? value
        ? "🟢 Yes"
        : "🔴 No"
      : value ?? "—"

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography variant="subtitle2" fontWeight="bold">
        {label}:
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {displayValue}
      </Typography>
    </Stack>
  )
}